import { Box, Button, Container, Text } from '@chakra-ui/react';
import NextLink from 'next/link';
import { useTranslation } from 'react-i18next';

import ArrowIcon from '@/assets/icons/ic-arrow.svg';

export const ContactUsSection = () => {
  const { t } = useTranslation();

  return (
    <Box
      bgImage="linear-gradient(180deg, #B6FFE2 0%, rgba(182, 255, 226, 0.00) 100%)"
      bgRepeat="no-repeat"
      pt={8}
      pb={32}
      textAlign="center"
    >
      <Container maxW="1040px">
        <Text fontFamily="heading" mb={8} fontWeight="bold" fontSize="3xl">
          {t('whiteGloveServicePage.contactUsHeading')}
        </Text>
        <Text mt={4}>{t('whiteGloveServicePage.contactUsDescription.0')}</Text>
        <Text mt={4}>{t('whiteGloveServicePage.contactUsDescription.1')}</Text>
        <Button
          as={NextLink}
          href="/contact-us/conferences"
          mt={8}
          variant="solid"
          colorScheme="black"
          alignSelf="flex-start"
          rightIcon={<ArrowIcon />}
        >
          {t('whiteGloveServicePage.contactUsButtonLabel')}
        </Button>
      </Container>
    </Box>
  );
};
